import { Button } from '@servicetitan/design-system';

export interface BookButtonProps {
    onClick: () => void;
}

export const BookButton = ({ onClick }: BookButtonProps) => {
    return (
        <Button fill="outline" size="small" iconName="event" primary onClick={onClick}>
            Book Us
        </Button>
    );
};
